module.exports = __webpack_public_path__ + "guanao-pc/static/media/logo.243b49d0.png";